import findBet from "../find-bet";
import pure from "./higher-order/pure";
import React from "react";
import survivorBetScore from "../survivor-bet-score";
import Towel, { SurvivorTowel } from "./towel";

export default pure(({ bets, number, race, raceEntrants, ticket, tournament }) => {
  if (tournament.get("tournament_type") === "Survivor") {
    return <SurvivorPlayFieldRaceTicket bets={bets} number={number} race={race} raceEntrants={raceEntrants} ticket={ticket} />;
  }
  var bet = findBet(bets, race.get("id"), ticket.get("id"));
  var entrant = bet ? raceEntrants.get(bet.get("race_entrant_id")) : undefined;
  if (bet && entrant) {
    /* var entrant = raceEntrants.get(bet.get("race_entrant_id"));*/
    var score = bet.get("score");
    return (
      <div className="game-table_cell game-table_cell--ticket">
        <Towel lane={entrant.get("lane_number")} score={score} />
      </div>
    );
  } else if (race.get("status") === "open") {
    return (
      <div className="game-table_cell game-table_cell--ticket">
        <span className="game-table_cta">
          Pick Now
        </span>
      </div>
    );
  }
  return (
    <div className="game-table_cell game-table_cell--ticket">
      <div className="dw-warning5 dw--1-25x color--is-medium-gray" />

      <span className="game-table_cta color--is-medium-gray">
        No Pick
      </span>
    </div>
  );
});

function SurvivorPlayFieldRaceTicket({ bets, number, race, raceEntrants, ticket }) {
  var previouslyEliminated = number <= ticket.get("eliminated_by_race_number");

  var bet = findBet(bets, race.get("id"), ticket.get("id"));

  if (!previouslyEliminated && !bet && race.get("status") === "open") {
    return (
      <div className="game-table_cell game-table_cell--ticket">
        <span className="game-table_cta">
          Pick Now
        </span>
      </div>
    );
  } else {
    var lane;
    if (bet) {
      var entrant = raceEntrants.get(bet.get("race_entrant_id"));
      if (entrant) {
        lane = entrant.get("lane_number");
      }
    }
    return (
      <div className="game-table_cell game-table_cell--ticket">
        <SurvivorTowel lane={lane} score={survivorBetScore(bet, race, number, ticket)} />
      </div>
    );
  }
}
